import {Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from "@angular/forms";
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'core-date-picker',
  templateUrl: './input-date-picker.component.html',
  styleUrls: ['./input-date-picker.component.scss', '../input.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: InputDatePickerComponent,
    multi: true
  }]
})
export class InputDatePickerComponent implements ControlValueAccessor, OnInit {
  faInfoCircle = faInfoCircle;

  @Input() id: string;
  @Input() label: string;
  @Input() topLabel: string;
  @Input() placeholder = '';
  @Input() showClearButton = true;
  @Input() showRevertButton = false;
  @Input() infoLabel: string;

  @Input() minDate: Date;
  @Input() maxDate: Date;

  @Input() removeDefaultBottomErrorMargin = false;

  @Output() onKeyUpEnter = new EventEmitter<string>();
  @Output() onRevert = new EventEmitter<any>();

  control: NgControl;
  value: string;
  disabled = false;
  private onTouched: Function;
  private onChanged: Function;

  constructor(private inj: Injector) {
    if (!this.id) {
      this.id = 'core-input-date-picker-' + Math.random();
    }
  }

  onClear() {
    this.valueChanged(null);
    this.onKeyUpEnter.emit(null);
  }

  ngOnInit() {
    this.control = this.inj.get(NgControl);
  }

  valueChanged(value: string) {
    this.onTouched();
    this.value = value;
    this.onChanged(value);
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: Function): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  onRevertPressed() {
    this.onRevert.emit();
  }

}
